import React, { useContext, useEffect, useState } from "react";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import List from "./UnitListTable";
import Pagination from "../Pagination";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import { Link, useLocation } from "react-router-dom";
import { Autocomplete, TextField } from "@mui/material";

function UnitManager() {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const manager =
    user?.permission?.find((e) => e.manager === "unit_manager") ?? {};
  const [propertyCategoryTypes, setPropertyCategoryTypes] = useState([]);
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [florOption, setFlorOption] = useState([]);
  const [bedroomOption, setBedroomOption] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    isReset: false,
    status: "",
    floor: "",
    bedroom: "",
    propertyType: "",
    projectId: "",
    isFilter: false,
    searchKey: "",
    projectId: "",
  });
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [sort, setSort] = useState({
    sortKey: "createdAt",
    sortType: "desc",
  });
  const [isInitialized, setIsInitialized] = useState(false);

  const {
    startDate,
    endDate,
    status,
    searchKey,
    floor,
    bedroom,
    propertyType,
    projectId,
  } = filterData;

  var florlength = 50;
  const getFlorOption = () => {
    let data = [];
    data.push({ key: `Ground Floor`, value: `Ground Floor` });
    for (var i = 1; i < florlength; i++) {
      data.push({ key: `${i} Floor`, value: `${i} Floor` });
    }
    setFlorOption(data);
  };

  var bedroomlength = 11;
  const getBedrooms = () => {
    let data = [];
    for (var i = 1; i < bedroomlength; i++) {
      data.push({ key: `${i}-Bedroom`, value: `${i}-Bedroom` });
    }
    setBedroomOption(data);
  };

  const getProjects = async () => {
    try {
      const path = apiPath.projectPath + "/all-projects";
      const result = await apiGet(path, {});
      setProjects(result?.data?.results || []);
    } catch (error) {
      console.error("error in get all projects list==>>>>", error.message);
    }
  };

  const fetchMasterRecords = async (data) => {
    try {
      const payload = { ...data };
      const path = apiPath.PropertiesMasterData;
      const result = await apiGet(path, payload);
      const records = result?.data?.results;
      const propertyTypes = records?.propertyTypes?.find(
        (res) => res.type === "Project",
      );
      const filteredCategories = records?.propertyCategories
        ?.filter((pt) => pt.propertyTypeId === propertyTypes?._id)
        .map((c) => ({ key: c.name, value: c._id }));
      setPropertyCategoryTypes(filteredCategories || []);
    } catch (error) {
      console.error("error in get all users list==>>>>", error.message);
    }
  };

  useEffect(() => {
    getProjects();
    getFlorOption();
    getBedrooms();
    fetchMasterRecords();
    getProjects();
  }, []);

  const fetchUnits = async (override) => {
    try {
      // const payload = {
      //   page,
      //   pageSize: pageSize,
      //   sortKey: sort.sortKey,
      //   sortType: sort.sortType
      // }
      const effective = override || {
        page,
        pageSize,
        startDate,
        endDate,
        searchKey,
        status,
        floor,
        bedroom,
        propertyType,
        projectId,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
      };
      const payload = {
        page: effective.page,
        pageSize: effective.pageSize,
        startDate: effective.startDate
          ? dayjs(effective.startDate).format("YYYY-MM-DD")
          : null,
        endDate: effective.endDate
          ? dayjs(effective.endDate).format("YYYY-MM-DD")
          : null,
        keyword: effective.searchKey ? effective.searchKey.trim() : null,
        status: effective.status,
        floor: effective.floor,
        bedroom: effective.bedroom,
        propertyType: effective.propertyType,
        projectId: effective.projectId || null,
        sortKey: effective.sortKey,
        sortType: effective.sortType,
      };
      const path = apiPath.unitPath;
      const result = await apiGet(path, payload);
      const response = result?.data?.results;
      const resultStatus = result?.data?.success;
      setList(response?.docs);
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null,
      });
    } catch (error) {
      console.log("error in get all users list==>>>>", error.message);
    }
  };
  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const handleDateChange = (start, end) => {
    setPage(1);
    setFilterData({
      ...filterData,
      startDate: start,
      endDate: end,
      isFilter: true,
    });
  };

  const handleChange = (event) => {
    setFilterData({
      ...filterData,
      isFilter: true,
      // searchKey:event.target.value,
      [event.target.name]: event.target.value,
    });

    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
      status: "",
      searchKey: "",
      bedroom: "",
      propertyType: "",
      projectId: "",
    });
    setSelectedProject(null);
    setPage(1);
  };

  const handleProjectChange = (_, newValue) => {
    setSelectedProject(newValue);
    setFilterData((prev) => ({
      ...prev,
      isFilter: true,
      projectId: newValue?._id || "",
    }));
    setPage(1);
  };

  useEffect(() => {
    const incoming = location?.state?.unitFilters;
    if (incoming) {
      setFilterData((prev) => ({
        ...prev,
        ...incoming,
        isFilter: true,
      }));
      if (incoming.projectId && projects.length) {
        const project = projects.find((p) => p._id === incoming.projectId);
        if (project) setSelectedProject(project);
      }
      setPage(1);
      setIsInitialized(true);
    } else {
      setIsInitialized(true);
    }
  }, [location?.state, projects]);

  useEffect(() => {
    if (!isInitialized) return;
    fetchUnits();
  }, [
    isInitialized,
    page,
    endDate,
    startDate,
    sort,
    status,
    searchKey,
    floor,
    bedroom,
    propertyType,
    projectId,
  ]);

  return (
    <div>
      <div className="bg-white">
        <div className="px-3 py-4">
          <div className="bg-white border border-[#E9EDF9] ">
            <form className="border-b border-b-[#E3E3E3] flex flex-wrap items-end gap-3 px-4 py-3">
              <div className="w-full md:w-60">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  {t("SELECT_PROJECT")}
                </label>
                <Autocomplete
                  id="unit-manager-project-autocomplete"
                  className="block w-full"
                  options={projects}
                  getOptionLabel={(option) => option?.title ?? ""}
                  isOptionEqualToValue={(option, value) =>
                    option._id === value._id
                  }
                  value={selectedProject}
                  onChange={handleProjectChange}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder={t("SELECT_PROJECT")}
                      size="small"
                      sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          fontSize: "0.875rem",
                          color: "#111827",
                          backgroundColor: "#f9fafb",
                          borderRadius: "0.5rem",
                          "& fieldset": {
                            borderWidth: "1px",
                            borderColor: "#d1d5db",
                          },
                          "&:hover fieldset": {
                            borderColor: "#d1d5db",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#3b82f6",
                            borderWidth: "1px",
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "8.5px 14px",
                          color: "#111827",
                          "&::placeholder": {
                            color: "#6b7280",
                            opacity: 1,
                          },
                        },
                        "& .MuiSvgIcon-root": {
                          color: "#6b7280",
                        },
                      }}
                    />
                  )}
                />
              </div>

              <div className="w-full md:w-44">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  {t("O_STATUS")}
                </label>
                <select
                  id="status"
                  name="status"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  value={status}
                  onChange={handleChange}
                >
                  <option value="">{t("O_STATUS")}</option>
                  <option value="Available">{t("O_AVAILABLE")}</option>
                  <option value="Not Available">Not Available</option>
                  <option value="Booked">Booked</option>
                  <option value="Sold Out">{t("O_SOLD_OUT")}</option>
                  <option value="Resale">Resale</option>
                </select>
              </div>

              <div className="w-full md:w-44">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  {t("O_FLOOR")}
                </label>
                <select
                  id="floor"
                  name="floor"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  value={floor}
                  onChange={handleChange}
                >
                  <option value="">{t("O_FLOOR")}</option>
                  {florOption.map((flr, idx) => (
                    <option key={idx} value={flr.value}>
                      {flr.key}
                    </option>
                  ))}
                </select>
              </div>

              <div className="w-full md:w-44">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  {t("O_BEDROOM")}
                </label>
                <select
                  id="bedroom"
                  name="bedroom"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  value={bedroom}
                  onChange={handleChange}
                >
                  <option value="">{t("O_BEDROOM")}</option>
                  {bedroomOption.map((flr, idx) => (
                    <option key={idx} value={flr.value}>
                      {flr.key}
                    </option>
                  ))}
                </select>
              </div>

              <div className="w-full md:w-44">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  {t("O_PROPERTY_TYPE")}
                </label>
                <select
                  id="propertyType"
                  name="propertyType"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  value={propertyType}
                  onChange={handleChange}
                >
                  <option value="">{t("O_PROPERTY_TYPE")}</option>
                  {propertyCategoryTypes.map((flr, idx) => (
                    <option key={idx} value={flr.value}>
                      {flr.key}
                    </option>
                  ))}
                </select>
              </div>

              <div className="w-full md:w-60">
                <label className="block mb-2 text-sm font-medium text-gray-900">
                  {t("O_SEARCH_BY_TITLE")}
                </label>
                <div className="relative w-full">
                  <input
                    type="search"
                    id="default-search"
                    name="searchKey"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 pr-10"
                    placeholder={t("O_SEARCH_BY_TITLE")}
                    value={searchKey}
                    onChange={(e) => handleChange(e)}
                  />
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg
                      aria-hidden="true"
                      className="w-4 h-4 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {!filterData?.searchKey && (
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      )}
                    </svg>
                  </div>
                </div>
              </div>

              <div className="w-full md:w-auto flex items-center gap-2">
                <button
                  type="button"
                  onClick={handleReset}
                  className="bg-[#8FC150] text-sm px-6 py-2.5 rounded-lg font-medium border border-transparent text-white hover:bg-[#7aa843] transition-colors"
                >
                  {t("O_RESET")}
                </button>
              </div>

              <div className="w-full md:w-auto flex items-center gap-3 ml-auto">
                {(manager?.add || user?.role === "admin") && (
                  <Link
                    title={t("O_ADD_UNIT")}
                    to="add-unit"
                    className="bg-[#8FC150] text-sm px-6 py-2.5 rounded-lg font-medium border border-transparent text-white hover:bg-[#7aa843] transition-colors whitespace-nowrap"
                  >
                    + {t("O_ADD_UNIT")}
                  </Link>
                )}
                {(manager?.import || user?.role === "admin") && (
                  <Link
                    title={t("O_IMPORT_UNITS")}
                    to="import-units"
                    className="bg-[#8FC150] text-sm px-6 py-2.5 rounded-lg font-medium border border-transparent text-white hover:bg-[#7aa843] transition-colors whitespace-nowrap"
                  >
                    + {t("O_IMPORT_UNITS")}
                  </Link>
                )}
              </div>
            </form>
            <List
              page={page}
              sort={sort}
              setSort={setSort}
              list={list}
              fetchUnits={fetchUnits}
              manager={manager}
              paginationObj={paginationObj}
              filterData={filterData}
            />
            {paginationObj?.totalItems ? (
              <Pagination
                handlePageClick={handlePageClick}
                options={paginationObj}
                page={page}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default UnitManager;
